<ng-template #content let-active="active">
  @if (figmaIcon(); as icon) {
    <lib-side-menu-icon
      [name]="icon"
      [active]="active"
      [iconClass]="active ? activeIconClass() : inactiveIconClass()" />
  } @else if (item().iconTemplate) {
    <span
      data-item-icon
      [class]="
        active ? activeTemplateIconClass() : inactiveTemplateIconClass
      "
      aria-hidden="true">
      <ng-container
        [ngTemplateOutlet]="item().iconTemplate!"
        [ngTemplateOutletContext]="{
          $implicit: active && !systemDefaultColor(),
        }" />
    </span>
  }
  <span data-label [class]="labelClass()">{{ item().label }}</span>
</ng-template>

@if (collapsed()) {
  <a
    [routerLink]="item().path"
    [routerLinkActive]="activeLinkClass()"
    ariaCurrentWhenActive="page"
    #rla="routerLinkActive"
    [libTooltip]="item().label"
    [hasCloseIcon]="false"
    [placement]="tooltipPlacement()"
    [class]="linkClass()">
    <ng-container
      [ngTemplateOutlet]="content"
      [ngTemplateOutletContext]="{ active: rla.isActive }" />
  </a>
} @else {
  <div class="flex h-3xl items-center gap-sm">
    <a
      [routerLink]="item().path"
      [routerLinkActive]="activeLinkClass()"
      ariaCurrentWhenActive="page"
      #rla="routerLinkActive"
      [class]="linkClass()">
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{ active: rla.isActive }" />
    </a>
    @if (item().quickAction; as action) {
      <lib-side-menu-quick-action [key]="key()" [action]="action" />
    }
  </div>
}
